/**
 * A class to store login request data
 */
export class LoginRequest {
  constructor(
    /** The user's email address */
    public email: string,
    /** The user's password */
    public password: string
  ) {}
}
